import {PlayerRef} from './Player.utils';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import {CallCardSource} from '@store/call-card/CallCardSource';
import {registerEvents} from 'utils/registerEvents';
import {Seconds} from '@store/@types/util';
import CallCardActions from '@store/call-card/CallCardActions';

/**
 * Handles creating listen records as a user listens to the call
 */
export function registerListenEvents(
  playerRef: PlayerRef,
  callId: FileUploadId,
  duration: Seconds
) {
  if (!playerRef) return () => null;
  let start: number | null = null;
  let end: number | null = null;

  const createListen = () => {
    if (start !== null && end !== null && start < end) {
      // Don't allow listen duration to run over call duration. Backend doesn't like that
      CallCardSource.createListen(callId, start, Math.min(end, duration))
        .then(() => CallCardActions.getUserCallActivity(callId))
        .catch(console.error);
      // Reset these immediately, don't await here. If we wait, we might overwrite a
      // separate listen start/end that began during the request.
      start = null;
      end = null;
    }
  };
  const updateStartTime = e => (start = e.target.currentTime);
  const updateEndTime = e => (end = e.target.currentTime);

  return registerEvents(playerRef, [
    // Play and Seeked determine where our listen starts
    ['play', updateStartTime],
    ['seeked', updateStartTime],
    // We update `end` continually while the video is playing
    ['timeupdate', updateEndTime],
    // When we pause or seek a new location or the call ends, save the current start/end state as a listen
    ['pause', createListen],
    ['seeking', createListen],
    ['ended', createListen],
  ]);
}
